import { createAsyncThunk } from "@reduxjs/toolkit";

import { getStaticPage } from "@/models";
import { AppState } from "@/redux/store/store";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";

export const fetchStaticPage = createAsyncThunk(
  "staticPage/fetchStaticPage",
  async (
    params: { permalink: string; config?: object },
    { getState, rejectWithValue }
  ) => {
    const { token } = fetchAuthToken(getState());
    try {
      const { adapter } = getState() as AppState;
      const { baseUrl } = adapter.adapter;
      const { permalink, config } = params;
      const response = await getStaticPage(
        token,
        baseUrl,
        permalink,
        {},
        config
      );

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
